import { useTranslation } from 'react-i18next';

const serviceData = [
  { icon: 'ri-stock-line', titleKey: 'services.s1.title', descKey: 'services.s1.desc', tag: 'Core' },
  { icon: 'ri-shield-check-line', titleKey: 'services.s2.title', descKey: 'services.s2.desc', tag: 'Legal' },
  { icon: 'ri-line-chart-line', titleKey: 'services.s3.title', descKey: 'services.s3.desc', tag: 'Analytics' },
  { icon: 'ri-customer-service-2-line', titleKey: 'services.s4.title', descKey: 'services.s4.desc', tag: 'Support' },
  { icon: 'ri-safe-line', titleKey: 'services.s5.title', descKey: 'services.s5.desc', tag: 'Insurance' },
  { icon: 'ri-exchange-dollar-line', titleKey: 'services.s6.title', descKey: 'services.s6.desc', tag: 'Payout' },
];

export default function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section id="services" className="bg-[#050508] py-16 md:py-24 px-4 md:px-6 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-amber-500/3 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-flex items-center gap-2 text-amber-400 text-xs font-['Rajdhani'] uppercase tracking-widest mb-3 md:mb-4">
            <div className="w-8 h-[1px] bg-amber-400" />
            {t('services.tag')}
            <div className="w-8 h-[1px] bg-amber-400" />
          </div>
          <h2 className="font-['Orbitron'] text-white font-black text-3xl md:text-5xl mb-3 md:mb-4">
            {t('services.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">{t('services.title2')}</span>
          </h2>
          <p className="text-gray-400 text-sm md:text-base max-w-xl mx-auto font-['Rajdhani']">{t('services.sub')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {serviceData.map((s) => (
            <div
              key={s.titleKey}
              className="group bg-[#0e0e1a] border border-white/5 hover:border-amber-500/30 rounded-2xl p-5 md:p-7 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start justify-between mb-4 md:mb-5">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-amber-500/10 group-hover:bg-amber-500/20 rounded-xl transition-colors duration-200">
                  <i className={`${s.icon} text-amber-400 text-lg md:text-xl`}></i>
                </div>
                <span className="text-amber-500/60 text-xs font-['Rajdhani'] uppercase tracking-widest border border-amber-500/20 px-2 py-1 rounded-full">
                  {s.tag}
                </span>
              </div>
              <h3 className="font-['Orbitron'] text-white font-bold text-sm md:text-base mb-2 md:mb-3 leading-snug">{t(s.titleKey)}</h3>
              <p className="text-gray-500 text-xs md:text-sm leading-relaxed font-['Rajdhani']">{t(s.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}